/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Dr_Final_TitleInputs */

const en_dr_final_title = /** @type {(inputs: Dr_Final_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Start with agreement, not a blank page`)
};

const id_dr_final_title = /** @type {(inputs: Dr_Final_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Mulai dari kesepakatan, bukan halaman kosong`)
};

/**
* | output |
* | --- |
* | "Start with agreement, not a blank page" |
*
* @param {Dr_Final_TitleInputs} inputs
* @param {{ locale?: "en" | "id" }} options
* @returns {LocalizedString}
*/
export const dr_final_title = /** @type {((inputs?: Dr_Final_TitleInputs, options?: { locale?: "en" | "id" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Dr_Final_TitleInputs, { locale?: "en" | "id" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "id") return id_dr_final_title(inputs)
	return en_dr_final_title(inputs)
});